import {
  BillingPeriods,
  UserSubscriptionBillingCycleUsageSummary,
  InstitutionMonthlyUsageSummary,
} from './types';

export enum ActionTypes {
  INSTITUTION_BILLING_CYCLE_USAGE_LOAD_START = 'INSTITUTION_BILLING_CYCLE_USAGE_LOAD_START',
  INSTITUTION_BILLING_CYCLE_USAGE_LOAD_SUCCESS = 'INSTITUTION_BILLING_CYCLE_USAGE_LOAD_SUCCESS',
  INSTITUTION_BILLING_CYCLE_USAGE_LOAD_FAIL = 'INSTITUTION_BILLING_CYCLE_USAGE_LOAD_FAIL',
  MONTHLY_USAGE_SUMMARY_LOAD_START = 'MONTHLY_USAGE_SUMMARY_LOAD_START',
  MONTHLY_USAGE_SUMMARY_LOAD_SUCCESS = 'MONTHLY_USAGE_SUMMARY_LOAD_SUCCESS',
  MONTHLY_USAGE_SUMMARY_LOAD_FAIL = 'MONTHLY_USAGE_SUMMARY_LOAD_FAIL',
  BILLING_PERIODS_LOAD = 'BILLING_PERIODS_LOAD',
  BILLING_PERIODS_LOAD_FAIL = 'BILLING_PERIODS_LOAD_FAIL',
}

export type InstitutionBillingCycleUsageLoadStarted = {
  type: ActionTypes.INSTITUTION_BILLING_CYCLE_USAGE_LOAD_START;
};

export type InstitutionBillingCycleUsageLoadSucceeded = {
  type: ActionTypes.INSTITUTION_BILLING_CYCLE_USAGE_LOAD_SUCCESS;
  data: UserSubscriptionBillingCycleUsageSummary;
};

export type InstitutionBillingCycleUsageLoadFailed = {
  type: ActionTypes.INSTITUTION_BILLING_CYCLE_USAGE_LOAD_FAIL;
  error: string;
};

export type MonthlyUsageSummaryLoadStarted = {
  type: ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_START;
};

export type MonthlyUsageSummaryLoadSucceeded = {
  type: ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_SUCCESS;
  data: InstitutionMonthlyUsageSummary;
};

export type MonthlyUsageSummaryLoadFailed = {
  type: ActionTypes.MONTHLY_USAGE_SUMMARY_LOAD_FAIL;
  error: string;
};

export type BillingPeriodsLoad = {
  type: ActionTypes.BILLING_PERIODS_LOAD;
  data: BillingPeriods;
};

export type BillingPeriodsLoadFail = {
  type: ActionTypes.BILLING_PERIODS_LOAD_FAIL;
};

export type InstitutionUsageAction =
  | InstitutionBillingCycleUsageLoadStarted
  | InstitutionBillingCycleUsageLoadSucceeded
  | InstitutionBillingCycleUsageLoadFailed
  | MonthlyUsageSummaryLoadStarted
  | MonthlyUsageSummaryLoadSucceeded
  | MonthlyUsageSummaryLoadFailed
  | BillingPeriodsLoad;
